import React from 'react';

import { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";


import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import DynamicCard from './DynamicCard';



// dynamic data
const data = [
  {
    id: 1,
    title: 'User Management',
    category: 'user management',
    description: 'Manage users, their profiles, roles, and permissions.',
    path: '/user-management',
    bgColor: '#f8f9fa', // Card background
    textColor: '#000',
    btnColor: '#00AEEF',
  },
  {
    id: 2,
    title: 'Reports',
    category: 'reports',
    description: 'View, generate, and analyze system activity and performance reports',
    path: '/reports',
    bgColor: '#f8f9fa',
    textColor: '#555',
    btnColor: '#d35400',
  },
  {
    id: 3,
    title: 'Account Admin',
    category: 'account admin',
    description: 'Administer account settings, security preferences, and access controls.',
    path: '/account-settings',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#3498db',
  },
  {
    id: 4,
    title: 'Statistics',
    category: 'statistics',
    description: 'Track and review usage statistics and other summaries.',
    path: '/statistics',
    bgColor: '#f8f9fa',
    textColor: '#333',
    btnColor: '#27ae60',
  },
  {
    id: 5,
    title: 'Content Management',
    category: 'content management',
    description: 'Organize, update, and control access to all content and resources.',
    path: '/content-management',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 6,
    title: 'Inventory Management',
    category: 'inventory management',
    description: 'Organize, update, delete and control access to all resources.',
    path: '/inventory-management',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 7,
    title: 'Lab Creation',
    category: 'lab creation',
    description: 'Create a new Product(Sandbox, Learnig and Showcase) or upgrade an existing product.',
    path: '/lab-creation',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
   {
    id: 8,
    title: 'File Management Services',
    category: 'file management services',
    description: 'Upload and protect files with secure storage and watermarking.',
    path: '/file-management-services',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 9,
    title: 'Instructor Access',
    category: 'instructer access',
    description: 'Create a List of New Users for the Trainings(Workshop).',
    path: '/instructer-access',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 10,
    title: 'Sign Up Requests',
    category: 'signup requests',
    description: 'Admins review and approve sign-up requests by assigning roles and updating status.',
    path: '/signup-requests',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 11,
    title: 'IP Information',
    category: 'ip information',
    description: 'Users can generate static IPs, and attach or detach them.',
    path: '/ip-information',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 12,
    title: 'Wizard Templates',
    category: 'wizard templates',
    description: 'User can delete wizard templates',
    path: '/wizard-templates',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 13,
    title: 'Archived Clusters',
    category: 'archived clusters',
    description: 'Manage archived clusters with details, view, and delete options.',
    path: '/archived-clusters',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },
  {
    id: 14,
    title: 'Automation Scripts',
    category: 'automation scripts',
    description: 'Manage automation scripts with details, view, and  options.',
    path: '/automation-scripts',
    bgColor: '#f8f9fa',
    textColor: '#000',
    btnColor: '#9b59b6',
  },

];

// Custom Styles
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    // minHeight: '100vh',
    fontFamily: '"Roboto", "Helvetica", sans-serif',
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    color: '#6F6F6F',
    fontSize: '2.2rem',
    fontWeight: 600,
    fontFamily: 'Roboto !important',
    textTransform: 'capitalize',
    lineHeight: 1.2,
    letterSpacing: '1px',
    // Subtle gradient or shadow to elevate
    background:  '#f8f9fa',
     borderRadius: 16,
     boxShadow: '0 6px 16px rgba(0,0,0,0.1)',


  },
  card: {
    borderRadius: 16,
    boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 10px 20px rgba(0,0,0,0.15)',
    },
  },
  content: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  titleText: {
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '1.1rem',
    margin: 0,
    color: '#1a1a1a',
  },
  desc: {
    fontSize: '0.9rem',
    color: '#666',
    margin: 0,
    opacity: 0.9,
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(2),
    padding: '8px 16px',
    backgroundColor: '#00AEEF',
    color: 'white',
    fontWeight: 500,
    fontSize: '0.9rem',
    borderRadius: 8,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#d35400',
      transform: 'scale(1.02)',
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
}));

function Management() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const profileData = JSON.parse(localStorage.getItem("profileData"));
    const account = profileData.account;
    let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
    let userEmail = JSON.parse(localStorage.getItem("profileData"))?.email;
    let hasDomain = domain?.some((res) => userEmail.includes(res));
    const [isInternal, setIsInternal] = useState(hasDomain);
    const enabled_roles = sessionStorage.getItem("enabled_roles") ? JSON.parse(sessionStorage.getItem("enabled_roles")) : ["Statistics"]
    const [filteredData, setFilteredData] = useState([]);



  useEffect(() => {
      const filtered_roles = data.filter(item => enabled_roles.includes(item.title));
      setFilteredData(filtered_roles);
      dispatch(SET_NAVBAR_TITLE(isInternal?account+"  - Settings":" Settings "));
    }, []);

    // dispatch(SET_NAVBAR_TITLE(isInternal ? account + "  - Settings" : " Settings "));



  return (
    <div className={classes.root}>
      <Typography variant="h2" className={classes.title}>
        Settings
      </Typography>

      <Grid container spacing={3}>
        {filteredData.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.id}>
            <DynamicCard
              item={item}
              style={{
                backgroundColor: item.bgColor,
                color: item.textColor,
              }}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Management;